import React from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
import Auth0ProviderWithHistory from './Auth0ProviderWithHistory';
import { isSessionError } from './hooks/useSessionGuard';
import { initTelemetry, TelemetryErrorBoundary } from './telemetry';

// Before the first render, so a crash during it is still reported.
initTelemetry();

const root = createRoot(document.getElementById('root')!);
// A request that fails because Auth0 wants the person to sign in again is not going to
// succeed on a retry; fail it at once so the session guard can send them to sign in.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: (count, error) => count < 3 && !isSessionError(error) },
  },
});

root.render(
  <TelemetryErrorBoundary>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Auth0ProviderWithHistory>
          <App />
        </Auth0ProviderWithHistory>
      </BrowserRouter>
    </QueryClientProvider>
  </TelemetryErrorBoundary>,
);
